import {nvTooltip, NvTooltip} from "./util/NVD3TooltipPatch";
import Payoff from "./payoff";

export default angular.module("tfApp.components.charts", [Payoff])
                      .directive(NvTooltip, nvTooltip)
                      .name;
